import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { handleUpdate, handleGet } from "../../../controllers/controller.all";
import SubmitButton from "../../../components/ui/SubmitButton";

export default function AdminUpdate() {
    const { id } = useParams();
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";
    const ecoleId = user?.ecole?._id || user?.ecole;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        nom: "",
        prenom: "",
        email: "",
        tel: "",
        adresse: "",
        genre: "",
        date_naissance: "",
        subrole: ""
    });

    useEffect(() => {
        const fetchAdmin = async () => {
            if (!id) return;
            await handleGet(`/user/${id}`, (res) => {
                if (res?.user) {
                    const t = res.user;
                    setFormData({
                        nom: t.nom || "",
                        prenom: t.prenom || "",
                        email: t.email || "",
                        tel: t.tel || "",
                        adresse: t.adresse || "",
                        genre: t.genre || "",
                        date_naissance: t.date_naissance || "",
                        subrole: t.subrole || ""
                    });
                }
            }, token);
        };
        if(token && id) fetchAdmin();
    }, [token, id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        const payload = {
            ...formData,
            role: "ADMIN",
            ecole: ecoleId
        };
        const res = await handleUpdate(e, `/user/${id}`, payload, setLoading, token);
        if (res) {
            navigate("/admins");
        }
    };

    return (
        <div className="flex flex-col gap-6 max-w-3xl mx-auto">
            <div className="flex items-center gap-4">
                <Link to="/admins" className="p-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition text-gray-500">
                    <ArrowLeft className="h-5 w-5" />
                </Link>
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Modifier l'Administrateur</h1>
                    <p className="text-sm text-gray-500">Mettez à jour les informations de l'administrateur.</p>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden">
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="col-span-1 border-b md:border-b-0 md:col-span-2 pb-4 mb-2 border-gray-200">
                        <h2 className="text-lg font-medium text-gray-900">Informations Personnelles</h2>
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Prénom *</label>
                        <input required type="text" name="prenom" value={formData.prenom} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Jean" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Nom de famille *</label>
                        <input required type="text" name="nom" value={formData.nom} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Dupont" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Email</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="jean@example.com" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Téléphone *</label>
                        <input required type="text" name="tel" value={formData.tel} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: +221 77..." />
                    </div>

                    <div className="space-y-2 md:col-span-2">
                        <label className="text-sm font-medium text-gray-700">Adresse</label>
                        <input type="text" name="adresse" value={formData.adresse} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Dakar, Sénégal" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Rôle spécifique</label>
                        <input type="text" name="subrole" value={formData.subrole} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Secrétaire, Directeur..." />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Genre</label>
                        <select name="genre" value={formData.genre} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white">
                            <option value="">Non spécifié</option>
                            <option value="M">Masculin</option>
                            <option value="F">Féminin</option>
                        </select>
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Date de naissance</label>
                        <input type="date" name="date_naissance" value={formData.date_naissance} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                </div>

                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                    <Link to="/admins" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                        Annuler
                    </Link>
                    <SubmitButton 
                        type="submit" 
                        isSubmitting={loading}
                        loadingText="Mise à jour..."
                        className="px-6 py-2"
                    >
                        Mettre à jour
                    </SubmitButton>
                </div>
            </form>
        </div>
    );
}
